import { render, staticRenderFns } from "./location.vue?vue&type=template&id=42d97bcc&scoped=true"
import script from "./location.vue?vue&type=script&lang=js"
export * from "./location.vue?vue&type=script&lang=js"
import style0 from "./location.vue?vue&type=style&index=0&id=42d97bcc&prod&lang=scss&scoped=true"
import style1 from "./location.vue?vue&type=style&index=1&id=42d97bcc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42d97bcc",
  null
  
)

export default component.exports